import { ModuleRouter } from "@/components/module-router/module-router";

export function AceRoutes() {
  return <ModuleRouter moduleId="ace" />;
}
